import { render, staticRenderFns } from "./NoveltyOrderComponent.vue?vue&type=template&id=4d2fdc32"
import script from "./NoveltyOrderComponent.vue?vue&type=script&lang=js"
export * from "./NoveltyOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports